<template>
  <div class="grid grid-cols-12 border rounded text-sm gap-x-4 p-4 items-center">
    <ValidationProvider
      rules="required"
      :name="`invoiceLines[${num}].description`"
      tag="div"
      :vid="`invoiceLines[${num}].description`"
      class="col-span-3"
    >
      <template #default="{ errors }">
        <BaseFormInput v-model="computedDescription" :disabled="disabled" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>

    <ValidationProvider
      rules="required"
      :name="`invoiceLines[${num}].quantity`"
      tag="div"
      :vid="`invoiceLines[${num}].quantity`"
    >
      <template #default="{ errors }">
        <BaseFormInput v-model="computedQuantity" type="number" min="1" :disabled="disabled" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>

    <ValidationProvider
      rules="required"
      :name="`invoiceLines[${num}].pricePerUnit`"
      tag="div"
      :vid="`invoiceLines[${num}].pricePerUnit`"
      class="col-span-2"
    >
      <template #default="{ errors }">
        <BaseFormInput
          v-model="computedPricePerUnit"
          type="number"
          min="0"
          step="0.01"
          :disabled="disabled"
        />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>

    <div class="text-right">{{ netAmount }} &euro;</div>

    <ValidationProvider
      rules="required"
      :name="`invoiceLines[${num}].vatRate`"
      tag="div"
      :vid="`invoiceLines[${num}].vatRate`"
      class="col-span-2"
    >
      <template #default="{ errors }">
        <BaseFormInput
          v-model="computedVatRate"
          type="number"
          min="0"
          step="0.01"
          :disabled="disabled"
        />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>

    <div class="text-right">{{ vatAmount }} &euro;</div>

    <div class="col-span-1 text-right">{{ total }} &euro;</div>

    <div class="text-right">
      <a role="button" @click="$emit('invoice-line-item:remove')"> Delete </a>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    num: {
      type: Number,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    quantity: {
      type: Number,
      default: 1,
    },
    pricePerUnit: {
      type: Number,
      default: 0,
    },
    vatRate: {
      type: Number,
      default: 0,
    },
    disabled: Boolean,
  },

  computed: {
    computedDescription: {
      get() {
        return this.description;
      },
      set(value) {
        this.$emit('update:description', value);
      },
    },
    computedQuantity: {
      get() {
        return this.quantity;
      },
      set(value) {
        if (Number.isNaN(value)) return;
        this.$emit('update:quantity', value);
      },
    },
    computedPricePerUnit: {
      get() {
        return this.pricePerUnit;
      },
      set(value) {
        if (Number.isNaN(value)) return;
        this.$emit('update:price-per-unit', value);
      },
    },
    computedVatRate: {
      get() {
        return this.vatRate;
      },
      set(value) {
        if (Number.isNaN(value)) return;
        this.$emit('update:vat-rate', value);
      },
    },
    netAmount() {
      return Number.parseFloat(Number.parseFloat(this.quantity * this.pricePerUnit).toFixed(2));
    },
    vatAmount() {
      return Number.parseFloat(Number.parseFloat(this.netAmount * this.vatRate).toFixed(2));
    },
    total() {
      return Number.parseFloat(Number.parseFloat(this.netAmount + this.vatAmount).toFixed(2));
    },
  },
};
</script>
